import { render, staticRenderFns } from "./KinvaDocShow.vue?vue&type=template&id=77ffcdeb"
import script from "./KinvaDocShow.vue?vue&type=script&lang=js"
export * from "./KinvaDocShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports